import { mapGetters, mapMutations } from 'vuex'

const isDragResize = {
	data() {
		return {
			isActive: false,
			isPermitDo: false,
			movieState: false
		}
	},
	computed: {
		...mapGetters('examination/configation', ['tempActiveArea'])
	},
	methods: {
		...mapMutations('examination/configation', ['setTempActiveArea']),
		exitDrag() {
		},
	}
}
export default isDragResize
